import { render, staticRenderFns } from "./unlikeIcon.vue?vue&type=template&id=db87fd24"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db87fd24')) {
      api.createRecord('db87fd24', component.options)
    } else {
      api.reload('db87fd24', component.options)
    }
    module.hot.accept("./unlikeIcon.vue?vue&type=template&id=db87fd24", function () {
      api.rerender('db87fd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/unlikeIcon.vue"
export default component.exports